import { CheckboxEditor } from "../../editors/checkboxEditor/index.mjs";
import { checkboxRenderer } from "../../renderers/checkboxRenderer/index.mjs";
export var CELL_TYPE = 'checkbox';
export var CheckboxCellType = {
  CELL_TYPE: CELL_TYPE,
  editor: CheckboxEditor,
  renderer: checkboxRenderer
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/checkboxType/checkboxType.mjs
// module id = 1091
// module chunks = 1